<div class="equis" (click)="onCancel()">X</div>
<h1 class="evento-title">Marketplace</h1>
<div class="evento-line"></div>
<div class="evento-desc">
  Selecciona la opción de mundo virtual que más se ajuste a la experiencia que
  quieras ofrecerle a tus clientes.
</div>

<div class="row cards">
  <div class="col-md-6 col-sm-12 card-media">
    <mat-card class="card-evento card">
      <div class="superior-line"></div>
      <mat-card-content>
        <p class="subtitle-evento">Centro comercial</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Crea tu propio centro comercial con locales y espacios personalizados
          . Permite que tus clientes lo recorran, en el mundo 3D por medio de un
          avatar y vayan de compras.
        </p>
        <img
          src="../../../../assets/images/infoverses-experiencia.png"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button mat-button class="btn btn-evento" (click)="openMallModal()">
          Construir
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col-md-6 col-sm-12 card-media">
    <mat-card class="card-evento card">
      <div class="superior-line"></div>
      <mat-card-content>
        <p class="subtitle-evento">Almacén</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Crea tu propio local comercial. Justo a tu medida. Estructura las
          góndolas en su interior y crear los productos a vas a ofrecer a tus
          clientes.
        </p>
        <img
          src="../../../../assets/images/almacen.png"
          alt=""
          class="img-evento almacen"
        />
      </mat-card-content>
      <mat-card-actions>
        <button
          disabled
          mat-button
          class="btn btn-evento"
          (click)="openListMallModal()"
        >
          Proximamente
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
